const GA_MEASUREMENT_ID = 'G-8J2HXZSQBC';
const COOKIE_CONSENT_KEY = 'planversion_cookie_consent';

let gaInitialized = false;

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export function initGoogleAnalytics() {
  if (gaInitialized) return;
  if (typeof window === 'undefined') return;

  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (consent !== 'accepted') return;

  gaInitialized = true;

  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag - must use function() to access arguments object
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: true });
}

/** Call on route changes to track SPA navigations */
export function trackGAPageView(path: string) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('config', GA_MEASUREMENT_ID, { page_path: path });
}

/** Track custom GA4 events */
export function trackGAEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', eventName, params);
}
